import script from "./ProductOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductOverview.vue?vue&type=script&setup=true&lang=js"

import "./ProductOverview.vue?vue&type=style&index=0&id=33c63a54&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33c63a54"]])

export default __exports__